<template>
  <div class="contact">
    <v-card flat="flat" class="nuclear">
      <v-card-title class="nuclear-title">Contact & Help</v-card-title>
      <v-card-text class="parent">
        <v-row justify="space-between">
          <v-col cols="12" md="6" class="bank">
            <v-card flat="flat">
              <v-card-title class="child">
                <p>Q&A Bank</p>
                <div class="search_part">
                  <font-awesome-icon class="search_icon" icon="search" />
                  <input
                    id="search"
                    type="text"
                    placeholder="Search Help"
                    v-model="search"
                  />
                </div>
              </v-card-title>
              <v-card-text class="child">
                <div
                  class="quiz_item"
                  v-for="item in filteredQuizes"
                  :key="item.id"
                >
                  <p>Sample Help Topic a Very Long Name Goes Here Below</p>
                  <v-btn class="read">READ</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" class="contact_part">
            <p class="answer">Didn’t find your answer? Send us a message.</p>
            <div class="contact_form">
              <v-form v-model="valid" ref="form" lazy-validation>
                <v-row>
                  <v-col class="name" cols="12" sm="6">
                    <v-text-field
                      v-model="username"
                      label="Your Name"
                      type="text"
                      :rules="fieldRules"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col class="email" cols="12" sm="6">
                    <v-text-field
                      v-model="email"
                      label="E-mail"
                      type="email"
                      :rules="emailRule"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="topic">
                  <v-autocomplete
                    v-model="topic"
                    label="Choose Your Topic"
                    :rules="fieldRules"
                    :items="topicOptions"
                    required
                  ></v-autocomplete>
                </v-row>
                <v-row class="meassage">
                  <label for="message">Your message</label>
                  <textarea
                    id="message"
                    rows="10"
                    v-model="message"
                    :rules="fieldRules"
                    required
                  ></textarea>
                </v-row>
                <v-row class="button">
                  <v-btn class="message" @click="SendMessage"
                    >SEND US A MESSAGE</v-btn
                  >
                </v-row>
                <p>{{ this.successmessage }}</p>
              </v-form>
            </div>
            <v-row class="contact_info">
              <v-col cols="12" sm="6">
                <p>1600 Amphitheatre Parkway</p>
                <p>Mountain View, CA 94043</p>
                <p>USA</p>
              </v-col>
              <v-col cols="12" sm="6">
                <p class="phone">p. 123 456 789</p>
                <p class="email1">contact@company.com</p>
                <p class="email2">contact2@company.com</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: "",
      email: "",
      topic: "",
      message: "",
      topicOptions: ["Topic1", "Topic2"],
      fieldRules: [v => !!v || "This field is Required"],
      emailRule: [
        v => !!v || "Email is required",
        v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || "Invalid e-mail.";
        }
      ],
      quiz_items: [
        {
          id: 1,
          quiz: "Sample Help the first topic a Very Long Name Goes Here Below"
        },
        { id: 2, quiz: "Sample Help Topic2 a Very Long Name Goes Here Below" },
        { id: 3, quiz: "Sample Help Topic3 a Very Long Name Goes Here Below" },
        { id: 4, quiz: "Sample Help Topic4 a Very Long Name Goes Here Below" }
      ],
      search: "",
      valid: false,
      successmessage: ""
    };
  },
  computed: {
    filteredQuizes() {
      return this.quiz_items.filter(item => {
        return item.quiz.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  methods: {
    SendMessage() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$store
        .dispatch("sendHelp", {
          name: this.username,
          email: this.email,
          topic: this.topic,
          message: this.message
        })
        .then(response => {
          this.successmessage = response.data.status;
        });
    }
  }
};
</script>
